export const EMeters = {
    ADD: 'ADD',
    EDIT: 'EDIT',
    LAST:'LAST'
}